<template>
	<div style='overflow:hidden;'>
		<div class="demo-upload-list" v-for="item in uploadList" :class='hasName?"":"active"'>
			<template v-if="item.status === 'finished'">

				<img :src="item.response.url | filterUrl" v-if='item.types=="pic"'>

				<img src="/dist/img/pdf.png" v-else-if='item.types=="pdf"'>

				<img src="/dist/img/doc.png" v-else-if='item.types=="doc"'>

				<img src="/dist/img/xls.png" v-else-if='item.types=="xls"'>
				<img :src="item.url" v-else-if='item.types=="default"'>
				<img src="/dist/img/img4.png" v-else>
				<span v-if='hasName'>{{item.name}}</span>

				<div class="demo-upload-list-cover">
					<Icon type="ios-eye-outline" @click.native="handleView(item.response.url,item.types)"></Icon>
					<Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
				</div>

			</template>
			<template v-else>
				<Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
			</template>
		</div>
		<Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList" :on-success="handleSuccess" :max-size="2048"
		 :on-format-error="handleFormatError" :data='extradata'  :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" :multiple='multipleFile'
		 type="drag" :action="actionUrl" style="display: inline-block;width:58px;">
			<div style="width: 58px;height:58px;line-height: 58px;">
				<Icon type="ios-camera" size="20"></Icon>
			</div>
		</Upload>
		<Modal title="查看文件" v-model="visible" fullscreen>
			<img :src="imgName" v-if="imgtype=='pic'" style="width: 100%;height:100%;">
			<iframe :src="imgName" frameborder="0" style='width:100%;height:100%;' v-else></iframe>
			<div slot="footer" style='display:none!important'>

			</div>
		</Modal>
	</div>
</template>
<script>
	export default {
		name: 'uploadFile',
		data() {
			return {
				defaultList: [

				],
				imgName: '',
				imgtype: '',
				visible: false,
				uploadList: [],
				actionUrl: '', // 提交的url,

			}
		},
		props: {
			reloadTmep: {
				type: Number
			},
      extradata:{
        type:Object,
        default:{},
      },
			checkList: {
				type: String,
				default: ''
			},
			multipleFile: { // 是否可以多选
				default: true
			},
			maxLen: { // 最大选择数量
				default: 100
			},
			hasName: {
				default: true
			}
		},
		watch: {
			checkList(val, oval) {

				console.log(val, 'val')
				var that = this
				if (val != '') {
					var data = val.split(",")
					var newval = []
					for (var i = 0; i < data.length; i++) {
						newval.push({
							name: '图片' + i,
							url: data[i],
							types: 'default',
							status: 'finished',
							response:{
								url:data[i]
							}
						})
					}
					console.log(newval)

					that.uploadList = newval

				}else{
					that.uploadList = []
				}
					that.$forceUpdate();
			},
			reloadTmep(nval, oval) {
				console.log(nval, oval)
				var that = this
				if (nval != oval) {
					that.$refs.upload.clearFiles()
					that.uploadList = []
					// that.$refs.upload.fileList.map(function(val,index){
					// 	that.$refs.upload.fileList.splice(index, 1);

					// })
				}
			}
		},
		mounted() {
			this.uploadList = this.$refs.upload.fileList;
      this.actionUrl = this.baseURL.imgURL
		},
		methods: {
			handleView(name, type) {

				if (type != 'pic') {
					var _filename = name.replace('139.196.217.92', 'display.incich.com')
					this.imgName = 'http://dcsapi.com/?k=53871581514327654406391&isCopy=0&url=' + _filename
				} else {
					if (name.indexOf("@") > -1) {
						this.imgName = name.split("@")[1];
					} else {
						this.imgName = name
					}

				}

				this.imgtype = type
				this.visible = true;
			},
			handleRemove(file) {
				console.log(file)
				const fileList = this.$refs.upload.fileList;
				this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				this.uploadList = this.$refs.upload.fileList
				this.$emit('emitParent', this.uploadList)
			},
			handleSuccess(res, val) {

				if (res.url) {

					var addr = val['name'].split(".")[1]
					if (["gif", "jpg", "jpeg", "png", "bmp"].indexOf(addr) > -1) {
						val['types'] = 'pic'
					} else if (["xls", "xlsx"].indexOf(addr) > -1) {
						val['types'] = 'xls'
					} else if (["doc", "docx"].indexOf(addr) > -1) {
						val['types'] = 'doc'
					} else if (["pdf"].indexOf(addr) > -1) {
						val['types'] = 'pdf'
					} else {
						val['types'] = 'noname'
					}

					this.uploadList.push(val)

					if (this.maxLen == 1) {
						var newArr = []
						newArr.push(this.uploadList.pop())
						this.$refs.upload.fileList = this.uploadList = newArr
						this.$emit('emitParent', this.uploadList)
					} else {
						this.$emit('emitParent', this.uploadList)
					}

				}


			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: '文件格式不正确',
					desc: '文件 ' + file.name + ' 格式支持'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: '文件过大',
					desc: '文件  ' + file.name + ' 过大, 最多不超过2M.'
				});
			},
			handleBeforeUpload(val) {
				var that = this
				return new Promise((resolve) => {
					this.$nextTick(function() {
						var addr = val['name'].split(".")
						addr = addr[addr.length - 1]
						var actionURL = this.actionUrl

						if (["gif", "jpg", "jpeg", "png", "bmp"].indexOf(addr) > -1) {

							this.actionUrl = this.actionUrl+'?ispress=1&thum=1&maxW=1920&maxH=1080&notkeeppic=1'
						} else {
							this.actionUrl = this.actionUrl
						}

						const check = this.uploadList.length < this.maxLen;
						if (!check) {
							this.$Notice.warning({
								title: '最多' + that.maxLen + '张图片.'
							});
							resolve(false);
						}
						resolve(true);
					});
				});


			},
		},
		filters: {

			filterUrl(val) {
				return val.split("@")[0]
			},

		}
	}
</script>
<style scoped>
	.demo-upload-list {
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		overflow: hidden;
		margin-right: 4px;

	}

	.demo-upload-list img {
		width: 58px;
		height: 58px;
		float: left;
		border-radius: 5px;

	}

	.demo-upload-list span {
		line-height: 40px;
		font-size: 12px;
		float: left;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
		overflow: hidden;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		line-height: 58px;
		width: 29px;
		text-align: center;
		float: left;
	}

	.demo-upload-list.active {
		float: left !important;
	}
</style>
